"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _lodash = _interopRequireDefault(require("lodash"));

var _propTypes2 = require("../../../helpers/prop-types");

var _common = require("../../../helpers/common");

var _useCustomSelect2 = _interopRequireDefault(require("./use-custom-select"));

var _reactRelativePortal = _interopRequireDefault(require("react-relative-portal"));

var _Checkbox = _interopRequireDefault(require("../Checkbox"));

var _TextField = _interopRequireDefault(require("../TextField"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var ALLOWED_MENU_KEYS = {
  ArrowDown: true,
  ArrowUp: true,
  End: true,
  Home: true,
  Enter: true,
  Escape: true
};

function Select(props) {
  var _selectedItems$, _cx2;

  var className = props.className,
      caretStyle = props.caretStyle,
      color = props.color,
      size = props.size,
      rounded = props.rounded,
      placeholder = props.placeholder,
      disabled = props.disabled,
      isSearchable = props.isSearchable,
      isMultiple = props.isMultiple,
      multipleItemLabel = props.multipleItemLabel,
      items = props.items,
      selectedItem = props.selectedItem,
      selectedItems = props.selectedItems,
      onChange = props.onChange,
      rest = _objectWithoutProperties(props, ["className", "caretStyle", "color", "size", "rounded", "placeholder", "disabled", "isSearchable", "isMultiple", "multipleItemLabel", "items", "selectedItem", "selectedItems", "onChange"]);

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      searchText = _useState2[0],
      setSearchText = _useState2[1];

  var filteredItems = isSearchable ? items.filter(function (_ref) {
    var label = _ref.label;
    return (0, _common.textSearchCompareByWord)(searchText, label);
  }) : items;

  var _useCustomSelect = (0, _useCustomSelect2.default)(isMultiple, isSearchable, {
    items: filteredItems,
    selectedItem: selectedItem,
    selectedItems: selectedItems,
    onChange: onChange
  }),
      isOpen = _useCustomSelect.isOpen,
      getToggleButtonProps = _useCustomSelect.getToggleButtonProps,
      getMenuProps = _useCustomSelect.getMenuProps,
      highlightedIndex = _useCustomSelect.highlightedIndex,
      getItemProps = _useCustomSelect.getItemProps,
      getDropdownProps = _useCustomSelect.getDropdownProps,
      searchInputRef = _useCustomSelect.searchInputRef;

  var selectClassName = (0, _classnames.default)('border flex justify-between items-center focus:outline-none w-full', className, _defineProperty({
    'pl-2 text-sm': size === 'small',
    'pl-3': size === 'medium',
    'hover:border-blue-400': color === 'default' && !disabled,
    'cursor-pointer': !disabled,
    'cursor-auto border-gray-medium': disabled,
    'rounded': rounded,
    'bg-white': !className.includes('bg')
  }, "border-".concat(color), color !== 'default' && !disabled));
  var labelForMultiple = _lodash.default.size(selectedItems) > 1 ? "".concat(selectedItems.length, " ").concat(multipleItemLabel) : selectedItems === null || selectedItems === void 0 ? void 0 : (_selectedItems$ = selectedItems[0]) === null || _selectedItems$ === void 0 ? void 0 : _selectedItems$.label;
  var shouldShowDropdown = isOpen && !disabled;
  return _react.default.createElement("div", {
    className: "relative w-full",
    "data-testid": "select"
  }, _react.default.createElement("button", _extends({
    type: "button",
    className: selectClassName
  }, getToggleButtonProps(getDropdownProps({
    preventKeyAction: isMultiple && isOpen
  })), rest), (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.label) ? _react.default.createElement("span", null, selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.label) : labelForMultiple ? _react.default.createElement("span", null, labelForMultiple) : placeholder ? _react.default.createElement("span", {
    className: "text-gray-medium"
  }, placeholder) : null, _react.default.createElement("div", {
    className: (0, _classnames.default)((_cx2 = {}, _defineProperty(_cx2, "bg-".concat(color, " text-white"), color !== 'default'), _defineProperty(_cx2, 'bg-gray-medium text-white', disabled), _cx2)),
    style: _objectSpread({
      padding: size === 'small' ? 9 : 11
    }, caretStyle)
  }, _react.default.createElement("svg", {
    className: "fill-current h-4 w-4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, _react.default.createElement("path", {
    d: "M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
  })))), _react.default.createElement(_reactRelativePortal.default, {
    component: "div",
    fullWidth: true,
    left: 0,
    right: 0,
    top: 1
  }, _react.default.createElement("ul", _extends({
    className: "focus:outline-none bg-white shadow absolute left-0 right-0 ",
    style: {
      zIndex: 70
    },
    "data-testid": "select-menu"
  }, getMenuProps({
    onKeyDown: function onKeyDown(event) {
      if (isSearchable && !ALLOWED_MENU_KEYS[event.key]) {
        event.nativeEvent.preventDownshiftDefault = true;
      }
    }
  })), shouldShowDropdown && _react.default.createElement(_react.default.Fragment, null, isSearchable && _react.default.createElement("div", {
    className: "p-3"
  }, _react.default.createElement(_TextField.default, {
    ref: searchInputRef,
    color: "primary",
    size: "small",
    rounded: false,
    value: searchText,
    onChange: function onChange(e) {
      return setSearchText(e.target.value);
    }
  })), _react.default.createElement("div", {
    className: "overflow-y-auto",
    style: {
      maxHeight: 180
    }
  }, filteredItems.map(function (item, index) {
    var isSelected = !!_lodash.default.find(selectedItems, {
      value: item === null || item === void 0 ? void 0 : item.value
    });
    var isSpacer = item.value === '|';
    return isSpacer ? _react.default.createElement("li", {
      key: "".concat(item.value).concat(index, "}"),
      style: {
        height: 16
      }
    }) : _react.default.createElement("li", _extends({
      key: item.value,
      className: (0, _classnames.default)('py-2 px-3 cursor-pointer', {
        'bg-gray-lighter': index === highlightedIndex,
        'text-sm': size === 'small',
        'flex items-center': isMultiple
      })
    }, getItemProps({
      item: item,
      index: index
    })), isMultiple && _react.default.createElement(_Checkbox.default, {
      className: "mr-2",
      size: "small",
      value: item.value,
      checked: isSelected,
      onClick: function onClick(e) {
        return e.preventDefault();
      }
    }), item.label);
  }))))));
}

Select.propTypes = {
  className: _propTypes.default.string,
  caretStyle: _propTypes.default.shape({}),
  color: _propTypes.default.string,
  // based on tailwind color
  size: _propTypes.default.oneOf(['small', 'medium']),
  rounded: _propTypes.default.bool,
  placeholder: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  isSearchable: _propTypes.default.bool,
  isMultiple: _propTypes.default.bool,
  multipleItemLabel: (0, _propTypes2.requiredIf)(_propTypes.default.string, function (props) {
    return props.isMultiple;
  }),
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.any
  })).isRequired,
  selectedItem: _propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.any
  }),
  selectedItems: (0, _propTypes2.requiredIf)(_propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.any
  })), function (props) {
    return props.isMultiple;
  }),
  onChange: _propTypes.default.func.isRequired
};
Select.defaultProps = {
  className: '',
  caretStyle: {},
  color: "default",
  size: 'medium',
  rounded: true,
  isSearchable: false,
  isMultiple: false,
  placeholder: 'Select an Option',
  onChange: function onChange() {}
};
var _default = Select;
exports.default = _default;